import ResearcherViewDialog from './ResearcherViewDialog';

export default ResearcherViewDialog ;